import { render, staticRenderFns } from "./_logout.vue?vue&type=template&id=46bb3cde&lang=pug&"
import script from "./_logout.vue?vue&type=script&lang=js&"
export * from "./_logout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports